// extracted by mini-css-extract-plugin
module.exports = {"sectionTitle":"SectionTitle_sectionTitle__yLWwF","textLeft":"SectionTitle_textLeft__65Nwq","description":"SectionTitle_description__VGhdZ"};